import ReactInputMask from "react-input-mask";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1000px;
  display: flex;
  overflow: hidden;
  flex-direction: column;

  h1 {
    color: #000;
  }

  h3 {
    font-size: 24px;
    margin-top: 5px;
    color: #3f8600;
    margin-bottom: 15px;
  }

  @media (max-width: 750px) {
    width: 95%;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  .next {
    margin-left: 15px;
    height: 40px;
    padding: 0 18px;
    border-radius: 45px;
    font-weight: 600;
    font-size: 16px;
    margin: 25px 0;
  }

  .row {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .buttonRight {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .service {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 14px;
    font-weight: 600;
    color: #000;
    border-bottom: 1px solid #afafaf;
  }

  .checkout-summary {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #f1f1f1;
    margin-top: 15px;
    font-weight: 600;
    flex-wrap: wrap;
  }

  .left-section {
    flex: 1;
    min-width: 250px;
  }

  .button {
    background-color: #007a3e;
    color: #fff;
    &:hover {
      background-color: #007a3ecc;
    }
  }

  .discount-info {
    margin: 0 0 10px;
    font-size: 14px;
    font-weight: 800;
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .right-section {
    text-align: right;
    flex: 1;
    min-width: 250px;
  }

  .line {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    gap: 10px;
  }

  .badge {
    background-color: #007a3e;
    color: white;
    padding: 6px;
    border-radius: 5px;
    font-size: 15px;
  }

  .final-label {
    font-weight: bold;
  }

  .amount {
    background: white;
    padding: 6px 8px;
    border-radius: 5px;
    font-size: 15px;
    font-weight: bold;
  }
`;

export const Docs = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 80%;
  justify-content: center;
  div {
    display: flex;
    flex-direction: column;
    padding: 10px;
    width: 120px;
    min-height: 200px;
    margin: 10px;
    background-color: #f0f0f0;
    margin-bottom: 15px;
    border-radius: 10px;
    align-items: center;
    justify-content: center;
    p {
      color: #000;
      text-align: center;
      width: 95%;
      word-break: break-all;
      margin-bottom: 15px;
    }
  }
`;

export const Files = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-start;
  font-weight: 600;

  div {
    display: flex;
    flex-direction: row;
    height: 35px;
    padding: 0 15px;
    margin: 0 10px 10px 0;
    background-color: #f0f0f0;
    border-radius: 40px;
    align-items: center;
    justify-content: center;
    p {
      color: #000;
      text-align: center;
      flex: 1;
      font-size: 14px;
      word-break: break-all;
    }
  }
`;

export const Services = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 15px;
  font-weight: 600;

  div {
    display: flex;
    padding: 8px 18px 8px 12px;
    margin-bottom: 10px;
    border-radius: 50px;
    height: auto;
    background-color: #f1f1f1;
    align-items: center;
    flex-direction: row;

    button {
      display: flex;
      height: 25px;
      padding: 0 10px;
      border-radius: 5px;
      align-items: center;
      justify-content: center;
      background-color: #008037;
      font-size: 12px;
      margin-left: 15px;
      color: #fff;
      font-weight: 600;
    }
    div {
      display: flex;
      padding: 0;
      margin: 0 15px 0 0;
      flex-direction: row;
      border: none;
      align-items: center;

      button {
        display: flex;
        height: 25px;
        width: 25px;
        padding: 0;
        border-radius: 20px;
        align-items: center;
        justify-content: center;
        background-color: #008037;
        font-size: 25px;
        color: #fff;
        margin-left: 0px;
        line-height: 25px;
      }
      span {
        margin: 0 10px;
      }
    }
    p {
      color: #000;
      flex: 1;
      overflow-wrap: break-word;
      word-break: break-word;
      white-space: normal;
    }
  }

  @media (max-width: 850px) {
    width: 100%;
  }
`;

export const ViewInput = styled.div`
  min-height: 40px;
  border-radius: 5px;
  width: calc(50% - 10px);
  margin-bottom: 5px;
  text-align: center;
  margin-right: 20px;
  min-width: 250px;

  p {
    width: 100%;
    font-size: 12px;
    text-align: left;
    margin: 0 0 2px 5px;
  }

  &.required-company-missing .ant-select-selector {
    background-color: #fffbe6 !important;
    border-color: #ffe58f !important;
  }

  @media (max-width: 750px) {
    min-width: 100%;
    margin-right: 0px !important;
  }
`;

export const Resume = styled.div`
  width: 100%;
  padding: 25px;
  margin: 10px 0;
  background-color: #f0f0f0;
  border-radius: 10px;
  align-items: center;
  justify-content: center;

  button {
    display: flex;
    padding: 10px;
    width: 100%;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    font-size: 18px;
    color: #000;
  }
`;

export const InputTel = styled(ReactInputMask)`
  box-sizing: border-box;
  margin: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  font-family: Montserrat;
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  background-color: #ffffff;
  background-image: none;
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
  border-radius: 2px;
  transition: all 0.2s;
  ::placeholder {
    color: #bbb;
    font-size: 13px;
  }
  &:hover {
    border-color: #008037;
  }
  input:focus {
    border-color: #008037;
  }
`;

export const ViewQRCode = styled.div`
  border-radius: 10px;
  padding: 20px;
  width: fit-content;
  margin-bottom: 12px;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.25); /* sombra em todos os lados */

  p {
    width: 100%;
    font-size: 12px;
    text-align: left;
    margin: 0 0 2px 5px;
    text-align: center;
    margin-top: 15px;
    font-weight: 600;
  }

  button {
    border-radius: 30px;
    height: 30px;
    margin-top: 10px;
  }
`;
